// extracted by mini-css-extract-plugin
export var active = "_i4-7";
export var blink = "_i4-8";
export var dropDownSelector = "_i4-4";
export var dropDownWrapper = "_i4-3";
export var fakeCursor = "_i4-6";
export var fontSizeButton = "_i4-9";
export var formQuillEditor = "_i4-0";
export var pressed = "_i4-a";
export var qlBlank = "_i4-1";
export var textFormattingToolbar = "_i4-2";
export var textToolbarOption = "_i4-5";